import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import React from 'react';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    body3: React.CSSProperties;
  }

  // allow configuration using createTheme
  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true;
  }
}

interface TypographyProps {
  id: string;
  children?: React.ReactNode;
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'textPrimary'
    | 'textSecondary'
    | 'textDisabled';

  variant?:
    | 'body1'
    | 'body2'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'caption'
    | 'subtitle1'
    | 'subtitle2'
    | 'body3';
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  fontStyle?: 'italic' | 'normal' | 'oblique';
  fontWeight?: 'normal' | 'bold' | 'inherit';
  className?: string;
  noWrap?: boolean;
}

const CustomTypography: FC<TypographyProps> = ({
  id,
  children,
  color = 'textPrimary',
  variant = 'body1',
  align = 'inherit',
  className,
  noWrap = false,
  ...rest
}) => {
  return (
    <Typography
      id={id}
      color={color}
      variant={variant}
      align={align}
      className={className}
      noWrap={noWrap}
      {...rest}
    >
      {children}
    </Typography>
  );
};

export default CustomTypography;
